import { createSlice } from "@reduxjs/toolkit";
import { fetchDiscountProductsThunk } from "./discountProductsThunk";

const initialState = {
    items: [],
    total: 0,
    totalPages: 0,
    loading: false,
    hasMore: true,
    error: null,
    page: 1
};

export const DiscountProductsSlice = createSlice({
    name: "discount-products",
    initialState,
    reducers: {
        hydrate: (state, action) => {
            const { content, totalElements, totalPages, last } = action.payload;
            state.items = content;
            state.total = totalElements;
            state.totalPages = totalPages;
            state.hasMore = !last;
        },
        removeItem: (state, action) => {
            const id = action.payload;
            state.items = state.items.filter( e => e.id !== id);
            state.total = state.total - 1;
        },
        resetDiscountProducts: (state) => {
            state.items = [];
            state.total = 0;
            state.totalPages = 0;
            state.page = 1;
            state.hasMore = true;
            state.error = null;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDiscountProductsThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDiscountProductsThunk.fulfilled, (state, action) => {
                state.loading = false;
                const data = action.payload;
                const products = data.content;
                state.items = products;
                state.total = data.totalElements;
                state.totalPages = data.totalPages;
                state.hasMore = !data.last;
            })
            .addCase(fetchDiscountProductsThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { 
    hydrate,
    resetDiscountProducts, 
    removeItem,
    setPage 
} = DiscountProductsSlice.actions;
export default DiscountProductsSlice.reducer;
